import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { usePhoneFactorProxy } from "../Custom Hooks/usePhoneFactorProxy";
import { Flex, Box, Center } from "@chakra-ui/react";
import { Button, ErrorMessage, Input, Typography } from "@sgi/gravity";
import { constructLogoutUri } from "../Custom Hooks/helpers";

export default function PhoneFactor() {
  const [verificationCode, setVerificationCode] = useState("");
  const url = window.location.href;
  const {
    sendCodeAction,
    callMeAction,
    verifyCodeAction,
    continueAction,
    cancelAction,
    sendANewCodeAction,
    showCodeVerification,
    pageError,
    verificationCodeError,
  } = usePhoneFactorProxy({ verificationCode });

  const onVerifyChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => setVerificationCode(e.target.value),
    []
  );
  const onVerifyKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") sendCodeAction.act();
    },
    [sendCodeAction]
  );

  const handleSendNewCodeAction = useCallback(() => {
    setVerificationCode("");
    sendANewCodeAction.act();
  }, [sendANewCodeAction]);

  // this is a temp solution to handle Cancel button click
  // https://dev.azure.com/SGICanDevOps/Identity/_workitems/edit/125297
  // if user cancels signin the error should be handled by redirect_uri destination (Microsoft behavior)
  const cancelActionAct = useCallback(() => {
    setVerificationCode("");
    let logoutUri = constructLogoutUri(url);
    window.location.replace(logoutUri);
  }, [url]);

  return (
    <Box>
      <Flex height={"100vh"} alignContent={"center"} justifyContent={"center"}>
        <Center>
          <Flex
            direction="column"
            maxW={468}
            mx="auto"
            background="white"
            data-testid="confirm-phone-factor-test"
          >
            {pageError && <ErrorMessage>{pageError}</ErrorMessage>}
            <Typography>
              For security, we need to send you a code to the phone registered
              with your account. Please choose your preferred method to receive
              that code:
            </Typography>
            {sendCodeAction.visible && (
              <Button
                isFullWidth
                data-testid="send-code-button-test"
                onClick={sendCodeAction.act}
                disabled={sendCodeAction.disabled}
                my={1}
              >
                Send Text Message
              </Button>
            )}
            {callMeAction.visible && (
              <Button
                isFullWidth
                data-testid="call-me-button-test"
                onClick={callMeAction.act}
                disabled={callMeAction.disabled}
                my={1}
              >
                Call Me
              </Button>
            )}
            {showCodeVerification && (
              <Input
                controlClassName="my-3"
                label="Verification code"
                name="Verification"
                id="verify-code-field"
                type="text"
                style={{ backgroundColor: "white" }}
                onChange={onVerifyChange}
                onKeyDown={onVerifyKeyDown}
                placeholder="Enter Verification code from email"
                error={verificationCodeError}
                data-testid="code-input-test"
                isRequired
                value={verificationCode}
                maxLength={6}
                pattern="\\d{6}"
                autoFocus
              />
            )}
            {showCodeVerification && verifyCodeAction.visible && (
              <Button
                isFullWidth
                data-testid="verify-code-button-test"
                onClick={verifyCodeAction.act}
                disabled={verifyCodeAction.disabled}
                my={1}
              >
                Verify Code
              </Button>
            )}
            {showCodeVerification && sendANewCodeAction.visible && (
              <Button
                isFullWidth
                data-testid="send-new-code-button-test"
                onClick={handleSendNewCodeAction}
                disabled={sendANewCodeAction.disabled}
                my={1}
              >
                Send A New Code
              </Button>
            )}
            {showCodeVerification && continueAction.visible && (
              <Button
                isFullWidth
                data-testid="continue-button-test"
                onClick={continueAction.act}
                disabled={continueAction.disabled}
                my={1}
              >
                Continue
              </Button>
            )}
            {cancelAction.visible && (
              <Button
                isFullWidth
                data-testid="cancel-button-test"
                onClick={cancelActionAct}
                disabled={cancelAction.disabled}
                my={1}
              >
                Cancel
              </Button>
            )}
          </Flex>
        </Center>
      </Flex>
    </Box>
  );
}
